import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import moment from 'moment';
import PropTypes from 'prop-types';
import Select from 'react-select';
import SelectDateFilter from 'modules/common/components/SelectDateFilter';
import Loading from 'modules/common/components/Loading';
import withDashboard from '../../../common/hoc/withDashboard';

import * as c from '../../constants';
import * as actions from '../../actions';

const styles = {
  control: (base) => ({
    ...base,
    minHeight: 24,
  }),
  dropdownIndicator: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
  }),
  clearIndicator: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
  }),
};

const rename = (obj, oldKey, newKey) => {
  if (_.has(obj, oldKey)) {
    _.set(obj, newKey, _.get(obj, oldKey));
    _.unset(obj, oldKey);
  }
  return obj;
};

const renderLegends = (dt) =>
  dt.map((x) => {
    return (
      <div key={x.name} className="legend-item">
        <div
          style={{
            background: `${x.color}`,
            width: 20,
            height: 20,
            marginRight: 20,
            borderRadius: '50%',
            fontSize: '12px',
          }}
        />
        <div className="legend-text">{x.name}</div>
      </div>
    );
  });

function StatisticsContainer({
  getDatedCounts,
  datedCounts,
  createDynamicLineChart,
}) {
  const [isLoading, setIsLoading] = useState(true);
  const [formData, setFormData] = useState({
    services: { label: 'E-GOVERNMENT', value: 'E-GOVERNMENT' },
  });

  // update later

  const handleChangeSelect = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e,
    });
  };

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1500);
    getDatedCounts({
      period: 'MONTHLY',
      date_from: moment().startOf('year').format('YYYY-MM-DD'),
      date_to: moment().endOf('year').format('YYYY-MM-DD'),
    });
  }, []);

  const handleOnSubmit = (data) => {
    getDatedCounts(data);
  };

  const filterEgovEServices = () => {
    const services = c.LAS_PINAS_STATISTICS || []

    return services
  }

  return (
    <div className="stat item-box-shadow">
      <div className="w-100">
        <h4 className="cms-text-primary font-weight-bold pl-2 mb-4">
          Statistics
        </h4>
      </div>
      <div className="d-none stat-header-container">
        {/* <div className="stat-title">Statistics</div> */}
        <div className="stat-select">
          {/* temporary hidden */}
          <Select
            styles={styles}
            placeholder="Select Service"
            value={_.get(formData, 'services')}
            options={c.SERVICES_SELECT}
            onChange={handleChangeSelect('services')}
          />
        </div>
      </div>

      <div className="stat-filters">
        <SelectDateFilter onSubmit={handleOnSubmit} />
      </div>
      {isLoading && <Loading />}
      {createDynamicLineChart(
        datedCounts.values,
        datedCounts.labels,
        {
          xAxisProps: {
            fontSize: '8px',
          },
          yAxisProps: {
          },
          composeOption: {
            bottom: 20,
          },
          size: 300,
        },
        isLoading
      )}
      <div className="legends-wrapper area px-3 w-100">
        <div
          className="render-chart-legends"
          style={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row',
            flexWrap: 'wrap',
          }}
        >
          {renderLegends(filterEgovEServices())}
        </div>
      </div>
    </div>
  );
}

const formatDatedCounts = (data) => {
  const labels = [];
  const values = [];

  const SERVICES = {
    CDL: 'Cedula',
    PSA: 'Civil Registry Office',
    OHP: 'Occupational / Health Permits',
    RPTS: 'RPTAX',
    BTAX: 'BTAX',
  };

  const colors = [
    '#007AB1',
    '#05B7EB',
    '#2F657D',
    '#04B5B5',
    '#055188',
    '#5DA5E0',
    '#4C6085',
    '#4C6085',
    '#323943',
    '#D5F2E8',
  ];

  data.forEach((item, i) => {
    const entries = Object.entries(item).filter(
      (a) => ['Real Property Tax (RPTAX)', 'Electronic Business Permit and Licensing System (eBPLS)'].indexOf(a[0]) > -1
    );

    if (i === 0) {
      entries.forEach((entry, x) => {
        labels[x] = {
          key: SERVICES[entry[0]] ? SERVICES[entry[0]] : entry[0],
          color: colors[x],
        };
      })
    }

    values[i] = rename(
      rename(
        rename(
          rename(item, 'OHP', 'Occupational / Health Permits'),
          'CDL',
          'Cedula'
        ),
        'PSA',
        'Civil Registry Office'
      ),
      'RPTS',
      'RPTAX'
    );
  });

  return {
    labels,
    values,
  };
};

StatisticsContainer.propTypes = {
  createDynamicLineChart: PropTypes.instanceOf(Function).isRequired,
  // // realTimeTransaction: PropTypes.instanceOf(Array).isRequired,
  getDatedCounts: PropTypes.instanceOf(Function).isRequired,
  datedCounts: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  datedCounts: formatDatedCounts(
    _.get(api, `${c.GET_DATED_COUNTS}.list`) || []
  ),
});

const enhance = _.flowRight([
  withDashboard,
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(StatisticsContainer);
